import React, { useCallback, useState } from 'react'
import ModalDeleteFract from './index'
import apis from '../../FractionApi'
import { styledLastFraction } from '../FractionLot/style'
import { FractionItem } from '../../FractionTypes'

const useDeleteFract = ({ setFractionTable }) => {
  const [deleteFract, setDeleteFract] = useState<FractionItem>()

  const handleClickFractRemove = useCallback((batch) => {
    setDeleteFract(batch)
  }, [])

  const handleFractRemove = async (badgeUser) => apis.removeFraction(deleteFract?.batchFractionId, badgeUser)
    .then(() => {
      setFractionTable((table) => {
        const newTable = table.filter((row) => row !== deleteFract)
        if (newTable.length) newTable[0].styleCell = styledLastFraction

        return Array.from(newTable)
      })
    })
    .catch((error) => {
      throw error
    })

  const removeFractionModalComponent = () => (
    <ModalDeleteFract
      deleteObject={deleteFract}
      cancelAction={() => setDeleteFract(undefined)}
      deleteAction={handleFractRemove}
    />
  )

  return [handleClickFractRemove, removeFractionModalComponent]
}

export default useDeleteFract
